export const SITE_URL = 'https://hamproductions.github.io/llll-chart';
export const SITE_BASE_PATH = '/llll-chart';
